import React  from "react";


const TypeCard = ({item, bg, setSelectedType, setOverlayOpen})=> {

  const select = ()=> {
    setSelectedType(item);
    setOverlayOpen({form:true});
  };

  return (
    <div className="currency-type-row" onClick={select} style={{backgroundColor: bg}}>
      <div className="left">
        <h6> {item.currencyName} ${item.amount} </h6>
        <p>  Points: {item.points} </p>
      </div>
      <div className="right">
        <img src={item.currencyIconSmall} />
      </div>
    </div>
  );
};

export default TypeCard;
